$(document).ready(function () {
  var maxDots = 5; // Maximum number of visible dots
  var $status = $('.pagingInfo');
  var $slickElement = $('.new-arrival-sec-pro-slider');

  // Custom dot updater
  /* function updateDots(slick) {
    if (!slick.$dots) return;

    var $dots = slick.$dots.find('li');
    var totalDots = $dots.length;
    var currentDot = Math.floor(slick.currentSlide / slick.options.slidesToScroll);

    // Determine range of visible dots
    var start = Math.max(0, currentDot - Math.floor(maxDots / 2));
    var end = Math.min(totalDots, start + maxDots);

    if (end - start < maxDots) {
      start = Math.max(0, end - maxDots);
    }

    $dots.hide(); // Hide all
    $dots.slice(start, end).show(); // Show limited
  } */

  // Event to update paging info + visible dots
  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
    if (!slick || typeof slick.slideCount === 'undefined' || slick.slideCount <= 1) return;
    let dots = slick.$slider.find(".slick-dots li").length;
    let dot_index = slick.$slider.find(".slick-dots").find("li.slick-active").index();
    console.log('dots',dots)
    console.log('dot index',dot_index)
    // var i = (typeof currentSlide === 'undefined' ? 0 : currentSlide) + 1;
    slick.$slider.closest(".tab-content").find(".pagingInfo").text(`${dot_index  + 1}/${dots}`);
    //$status.text(i + '/' + slick.slideCount);
    //updateDots(slick);
  });

  // Initialize Slick
  $slickElement.slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4.2,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1
        }
      }
    ]
  });

  // ✅ Trigger pagingInfo update on initial load
  /* $slickElement.on('init', function (event, slick) {
    var i = slick.currentSlide + 1;
    $status.text(i + '/' + slick.slideCount);
    updateDots(slick);
  }); */

  /* $slickElement.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    console.log(nextSlide);
    console.log("event",event)
    console.log("slick",slick)
  }); */
     

  // ✅ Force initial trigger (in case init event doesn't fire early enough)
  var slickInstance = $slickElement.slick('getSlick');
  $slickElement.trigger('init', [slickInstance]);

  // Reinitialize on tab click
  $('.new-arrival-sec .tab').on('click', function () {
    var slickInstance = $('.new-arrival-sec-pro-slider').slick('getSlick');
    $('.new-arrival-sec-pro-slider').slick('refresh');
    //updateDots(slickInstance);
  });
});
